/**
 * Pantalla: MapaGRSMM
 * Component: PantMapaGRSMM.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.1
 * Data: 19/12/2017
 * (c) Ajuntament de Manresa - dic 2017 - Departament de Sistemes d'Informació
 * Per mostrar indicadors en un mapa
 */

import * as React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Button, Checkbox, /* InputBase, */ FormControlLabel, IconButton, Menu, MenuItem, Tooltip, Typography, TextField } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { MapComponent } from '@terrestris/react-geo';
import OlLayerImage from 'ol/layer/Image';
import OlImageSource from 'ol/source/Image';
import OlLayerTile from 'ol/layer/Tile';
import OlTileSource from 'ol/source/Tile';
import { IPropsMapa } from '../interfaces/IPropsMapa';
import MapaGRSMMState from '../states/MapaGRSMMState';
import MyLayerSwitcher from '../controls/MyLayersSwitcher';
import MyLayerSwitcher2 from '../controls/MyLayersSwitcher2';
import MyZoomToExtent from '../controls/MyZoomToExtent';
import 'ol/ol.css';
import 'antd/dist/antd.min.css';
import '../css/react-geo.css';
import '../css/MyControls.css';
import '../css/Mapa.css';
import '../css/GRSMM.css';
import { ExpandMore, Link, AddCircleOutline } from '@material-ui/icons';
import { ILayer, ILayerGroup, IFilterGroup, IUrl } from '../interfaces/ILayer';
import { AppDrawer, AppToolBar, AppToolBarElements } from 'ajt-app';

@inject('appState')
@observer
export default class PantMapaGRSMM extends React.Component<IPropsMapa, object> {
    constructor(props: IPropsMapa) {
        super(props);
        // Creem el mpState - Els paràmetres el processem dins de createMap de GRSMMState
        this.mGRSMMState = new MapaGRSMMState(this.props);
        // Events pel canvi de mida de la pantalla
        this.mGRSMMState.updateWindowSize();
        this.autoSize = true;
    }

    // El estat del mapa
    private mGRSMMState: MapaGRSMMState;

    // Diu si agafem les mides de la pantalla
    private autoSize = false;

    updateDimensions() {
        if (this.autoSize) {
            this.mGRSMMState.updateWindowSize();
        }
    }

    // Per posar si cal la resposta a l'event de resize
    componentDidMount() {
        if (this.autoSize) {
            window.addEventListener('resize', this.updateDimensions.bind(this));
        }
    }

    // Per treure si cal la resposta a l'event de resize
    componentWillUnmount() {
        if (this.autoSize) {
            window.removeEventListener('resize', this.updateDimensions.bind(this));
        }
    }

    // Hem canviat de BaseLayer
    private handleBaseLayerChanged = (layerSelected: OlLayerTile<OlTileSource> | OlLayerImage<OlImageSource>) => {
        this.mGRSMMState.actBaseLayer = layerSelected;
        // La capa de noms només la volem activa als layers de Planejament i Ortofoto
        if (this.mGRSMMState.nomsLayer) {
            const id: string = layerSelected.get('id');
            const ld: ILayer = this.mGRSMMState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
            if (ld && ld.noms) {
                this.mGRSMMState.nomsLayer.set('visible', this.mGRSMMState.nomsVisible);
                this.mGRSMMState.setShowNoms(true);
            } else {
                this.mGRSMMState.nomsLayer.set('visible', false);
                this.mGRSMMState.setShowNoms(false);
            }
        }
    }

    // Activem o desactivem la capa de noms
    private handleCBNomsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.mGRSMMState.nomsLayer.setVisible(event.target.checked);
        this.mGRSMMState.setNomsVisible(event.target.checked);
    };

    // Activem o desactivem una capa de referència
    // En GRSMM no hi ha altres RefLayers, per tant aquesta part no s'executarà mai
    private handleCBRefLayerChange = (id: string, event: React.ChangeEvent<HTMLInputElement>) => {
        const i = this.mGRSMMState.getRefLayerIndex(id);
        if (i >= 0) {
            this.mGRSMMState.refLayers[i].setVisible(event.target.checked);
            this.mGRSMMState.setRefLayerVisible(i, event.target.checked, true);
        }
    }

    //funcio per fer "querys"
    // Rederitza un Layer o un LayerGroup o un Filter dins d'un Layer
    private renderLayerComponent = (ly: ILayer | ILayerGroup) => {
        if (ly.type === 'wms' || ly.type === 'wmts') {
            const rll: ILayer = ly as ILayer;
            if (rll.id == "grsmm") {
                const i = this.mGRSMMState.getRefLayerIndex(rll.id);
                if (i >= 0) {
                    this.mGRSMMState.refLayers[i].setVisible(true);
                    this.mGRSMMState.setRefLayerVisible(i, true, true);
                }
                return (<></>);
            } else { // En GRSMM no hi ha altres RefLayers, per tant aquesta part no s'executarà mai
                return (<Accordion square elevation={0} style={{ padding: 0, minHeight: 20 }} expanded={false} key={'ac' + rll.id}>
                    <AccordionSummary key={'gr' + rll.id} style={{ height: 32, maxHeight: 32, minHeight: 20 }}>
                        <FormControlLabel
                            style={{ fontSize: '12px', padding: 0, marginLeft: -6 }}
                            key={'fcl' + rll.id}
                            control={<><Checkbox
                                key={'cb' + rll.id}
                                checked={(this.mGRSMMState.actRefLayers[this.mGRSMMState.getRefLayerIndex(rll.id)])}
                                onChange={this.handleCBRefLayerChange.bind(this, rll.id)}
                                name={rll.id}
                                style={{ padding: 0 }}
                            />{!!rll.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rll.icon} alt={rll.name} width={16} height={16} />&nbsp;</>}</>}
                            label={<Typography variant="body2">{rll.name}</Typography>}
                        />
                    </AccordionSummary>
                </Accordion>);
            }
        } else if (ly.type === 'grp') { // En GRSMM no hi ha grups, per tant aquesta part no s'executarà mai
            const rlg = ly as ILayerGroup;
            return (<Accordion square elevation={0} style={{ padding: 0, minHeight: 20 }} key={'ac' + rlg.id}>
                <AccordionSummary key={'gr' + rlg.id} expandIcon={<ExpandMore />} style={{ height: 32, maxHeight: 32, minHeight: 20 }}>
                    {!!rlg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rlg.icon} alt={rlg.name} width={16} height={16} />&nbsp;</>}
                    <Typography variant="body2">{rlg.name}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: 'grid', padding: 0, minHeight: 20 }} key={'acd' + rlg.id}>
                    {rlg.layers.map((rl) => { return this.renderLayerComponent(rl); })}
                </AccordionDetails>
            </Accordion>);
        } else if (ly.type === 'filter') {
            const rlg = ly as IFilterGroup;
            const formlabel = [<></>];
            rlg.elements.forEach(element => {
                formlabel.push(
                    <FormControlLabel
                        style={{ fontSize: '12px', padding: 0, marginLeft: 2 }}
                        control={<Checkbox
                            id={rlg.feature + element.value}
                            onChange={() => {
                                const filterExists = this.mGRSMMState.filters.some((e) => e.feature == rlg.feature && e.value == element.value);
                                if (!filterExists) {
                                    this.mGRSMMState.boxcheked.push(rlg.feature + element.value);
                                    this.mGRSMMState.filters.push({ feature: rlg.feature, value: element.value })
                                } else {
                                    if (this.mGRSMMState.boxcheked.includes(rlg.feature + element.value)) {
                                        this.mGRSMMState.boxcheked.splice(this.mGRSMMState.boxcheked.indexOf(rlg.feature + element.value), 1);
                                    }
                                    for (let i = 0; i < this.mGRSMMState.filters.length; i++) {
                                        const element2 = this.mGRSMMState.filters[i];
                                        if (element2.feature == rlg.feature && element2.value == element.value) {
                                            this.mGRSMMState.filters.splice(i, 1);
                                        }
                                    }
                                }
                                this.mGRSMMState.setqSelect(this.mGRSMMState.refLayers[0], this.mGRSMMState.getLayerExtraParms2(this.mGRSMMState.mapConfig.refLayers[0] as ILayer).qfilter);
                                this.mGRSMMState.refLayers[0].getSource().refresh();
                            }}
                        />}
                        label={element.name} 
                    />
                )
            });
            return (<Accordion square elevation={0} style={{ padding: 0, minHeight: 20 }} key={'ac' + rlg.id} expanded={true}>
                <AccordionSummary key={'gr' + rlg.id} expandIcon={<ExpandMore />} style={{ height: 32, maxHeight: 32, minHeight: 20 }} >
                    {!!rlg.icon && <><img src={process.env.PUBLIC_URL + '/img/' + rlg.icon} alt={rlg.name} width={16} height={16} />&nbsp;</>}
                    <Typography variant="body2">{rlg.name}</Typography>
                </AccordionSummary>
                <AccordionDetails style={{ display: 'grid', padding: 0, minHeight: 20 }} key={'acd' + rlg.id}>
                    {formlabel}
                </AccordionDetails>
            </Accordion>);
        } else {
            return null;
        }
    }

    private handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.mGRSMMState.setAnchorEl(event.currentTarget)
    }

    private handleMenuClose = (index: number) => {
        this.mGRSMMState.setAnchorEl(null);
        if (index >= 0) {
            window.open(this.mGRSMMState.mapConfig.descarrega[index].url, this.mGRSMMState.mapConfig.descarrega[index].name);
        }
    }

    // Va al formulari de Google per afegir una entitat
    private handleAddEnt = () => {
        window.open("https://docs.google.com/forms/d/e/1FAIpQLSeScUySyDGZxSM9O2Tw7eioA-kJcuTNOi842sDQAKeKVqKplw/viewform?vc=0&c=0&w=1&flr=0");
    }

    // Mostra un diàleg amb l'enllaç
    private handleGetLink = () => {
        // Posar un popup amb el link
        // Protocol i host
        let url: string = window.location.protocol + '//' + window.location.hostname;
        // Port
        if (window.location.port && window.location.port !== '80' && window.location.port != '443') {
            url += ':' + window.location.port;
        }
        // Path
        url += window.location.pathname;
        // Centre del mapa i Zoom
        const c = this.mGRSMMState.olview.getCenter();
        url += '?Pos=' + c[0].toFixed(2) + ';' + c[1].toFixed(2) + ';' + this.mGRSMMState.olview.getZoom().toFixed(0);
        // Marcador
        if (this.mGRSMMState.position) {
            url += ';' + this.mGRSMMState.position[0].toFixed(2) + ';' + this.mGRSMMState.position[1].toFixed(2);
        }
        // BaseLayer
        const id: string = this.mGRSMMState.actBaseLayer.get('id');
        const ld: ILayer = this.mGRSMMState.mapConfig.baseLayers.find((l: ILayer) => l.id === id);
        url += '&Base=' + ld.layers;

        this.props.appState.dialState.messageBox({
            title: 'Enllaç',
            message: url,
            buttons: navigator.clipboard ? ['Copiar URL', 'Acceptar'] : ['Acceptar']
        }).then((result) => {
            if (result === 'Copiar URL') {
                navigator.clipboard.writeText(url);
                this.props.appState.notiState.showMessage('URL copiada');
            }
        });
    }

    render() {
        if (!this.mGRSMMState.configOk) {
            return null;
        }

        const w: number = this.mGRSMMState.width; // Amplada de la finestra
        const drw: number = this.props.appState.menuState.marginDrawer; // Amplada el drawer
        const wx: string = (w - drw).toString() + 'px'; // Amplada del mapa

        const mto: string = w < 601 ? (w < 600 ? '96px' : '112px') : '112px'; // Posició top del mapa
        const h: number = this.mGRSMMState.height - 106 + (w < 601 ? (w < 600 ? 16 : 8) : 0); // Alçada del mapa
        const hx: string = h.toString() + 'px'; // Alçada del mapa

        const lx: string = w < 601 ? '.5em' : 'calc(50% - ' + ((w / 2) - 270) + 'px)'; // Esquerra del layer switcher
        const bx: string = 'calc(100% - ' + (h + (w < 601 ? 80 : 90)).toString() + 'px)'; // Bottom del layer switcher

        const thc = w < 601 ? (w < 600 ? '106px' : '122px') : '122px';  // Posició (superior) del control de capa de noms
        const rhc = 'calc(100% - ' + (w + 5).toString() + 'px)'; // Posició (dreta) del control de capa de noms

        return (
            <>
                <AppToolBar style={{ zIndex: 1300 }} showHelp={true}>
                    <AppToolBarElements alignment='right'>
                        {this.mGRSMMState.mapConfig.descarrega && this.mGRSMMState.mapConfig.descarrega.length > 0 && <><Button onClick={this.handleMenuClick}>Descàrrega de mapes ...</Button>
                            <Menu
                                id="simple-menu"
                                anchorEl={this.mGRSMMState.anchorEl}
                                keepMounted
                                open={Boolean(this.mGRSMMState.anchorEl)}
                                onClose={this.handleMenuClose.bind(this, -1)}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                                transformOrigin={{ vertical: 'top', horizontal: 'center', }}
                            >
                                {this.mGRSMMState.mapConfig.descarrega.map((item: IUrl, index: number) => {
                                    return (<MenuItem key={'dsc' + index} onClick={this.handleMenuClose.bind(this, index)}>{item.name}</MenuItem>);
                                })}
                            </Menu></>}
                        <Tooltip title="Sol·litar afegir entitat">
                            <IconButton onClick={this.handleAddEnt} key="addEnt">
                                <AddCircleOutline />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Enllaçar">
                            <IconButton onClick={this.handleGetLink} key="iblink">
                                <Link />
                            </IconButton>
                        </Tooltip>
                    </AppToolBarElements>
                </AppToolBar>
                <AppDrawer variant={w < 601 ? 'temporary' : 'permanent'}>
                    {
                        <>
                            <TextField
                                placeholder="Cerca per nom"
                                fullWidth={true}
                                className="ibase"
                                variant= "outlined"
                                onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                                    this.mGRSMMState.nomFilter = event.target.value;
                                    this.mGRSMMState.setqSelect(this.mGRSMMState.refLayers[0], this.mGRSMMState.getLayerExtraParms2(this.mGRSMMState.mapConfig.refLayers[0] as ILayer).qfilter);
                                    this.mGRSMMState.refLayers[0].getSource().refresh();
                                }}
                            />
                            {this.mGRSMMState.mapConfig.refLayers.map((rl) => {
                                return this.renderLayerComponent(rl);
                            })}
                        </>
                    }
                </AppDrawer>
                <>
                    {this.mGRSMMState.olmap && <MapComponent map={this.mGRSMMState.olmap} style={{ width: wx, height: hx, cursor: this.mGRSMMState.identPosition ? 'crosshair' : this.mGRSMMState.identElement ? 'pointer' : 'default', position: 'fixed', top: mto }} />}
                    {this.mGRSMMState.olmap && <MyZoomToExtent map={this.mGRSMMState.olmap} tooltip="Zoom total" extent={this.mGRSMMState.mapConfig.initialExtent} />}
                    {this.mGRSMMState.baseLayers.length === 2 && <MyLayerSwitcher
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2
                        }}
                        map={this.mGRSMMState.olmap}
                        layers={this.mGRSMMState.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls1"
                    />}
                    {this.mGRSMMState.baseLayers.length > 2 && <MyLayerSwitcher2
                        style={{
                            position: 'absolute',
                            bottom: bx,
                            left: lx,
                            zIndex: 2,
                            backgroundColor: 'rgba(250, 250, 250, 0.8)'
                        }}
                        map={this.mGRSMMState.olmap}
                        layers={this.mGRSMMState.baseLayers}
                        onBaseLayerChanged={this.handleBaseLayerChanged}
                        key="myls2"
                    />}
                    {this.mGRSMMState.showNoms && <FormControlLabel
                        style={{ zIndex: 1, backgroundColor: 'rgba(250, 250, 250, 0.9)', position: 'absolute', right: rhc, top: thc }}
                        control={<Checkbox
                            checked={this.mGRSMMState.nomsVisible}
                            onChange={this.handleCBNomsChange}
                            name="cbNoms"
                        />}
                        label={<Typography variant="body2">{this.mGRSMMState.nomsLayer.get('name')}</Typography>}
                        title='Activar o desactivar la capa de noms de carrers i de números postals'
                    />}
                </>
            </>
        );
    }
}